import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { map, of } from "rxjs";
import { EmployeeService } from "src/app/company/services/employee.service";
import { IBaseSearchRequest } from "src/app/core/models/base";

export function EmployeeEmailValidator(employeeService: EmployeeService): AsyncValidatorFn {
    return  (control: AbstractControl) => {
        const request : IBaseSearchRequest= {
            pageNumber:0,
            pageSize: 999999,
            advancedFilter:{
                logic: "and",
                filters: [
                    {
                        field: 'email',
                        operator: 'eq',
                        value: control.value

                    }
                ]
            }
        }
        // check if form has yet been changed
        // prevent unessecary api call and inital error message
        if(!control.pristine){
          return employeeService.getEmployees(request)
          .pipe(
              map(response => {
                  const employees = response.data;
                  return employees.length != 0 ? {emailExists: true} : null;
              })
          )
        } else {
          return of(null);
        }
    }
}
